import React from 'react'
import List from '@mui/material/List'
import { Link, useLocation, useNavigate } from 'react-router'
import { PressReleaseLight } from '@finance-lab/utils/types'
import { flagPath } from '../entities/CompaniesGrid'
import { getPressReleaseLink } from '../../utils/get-press-release-link'
import { resolveLanguage, type SupportedLanguage } from '../../i18n/languagePreference'
import { setPressReleasePreferredLanguage } from '../../utils/pressReleaseLanguagePreference'

const mapLanguageToCountry = (language: string) => {
    switch (language) {
        case 'en':
            return 'us'
        case 'sv':
            return 'se'
        case 'da':
            return 'dk'
        case 'ja':
            return 'jp'
        case 'zh':
            return 'cn'
        case 'ko':
            return 'kr'
        default:
            return language
    }
}

type PressReleaseLanguageToggleProps = {
    companyId: string
    translations: PressReleaseLight['translations']
}

export function PressReleaseLanguageToggle({ companyId, translations }: PressReleaseLanguageToggleProps) {
    const navigate = useNavigate()
    const location = useLocation()

    const translationOptions = translations.filter(
        (translation) => translation.language === 'sv' || translation.language === 'en',
    )

    if (translationOptions.length === 0) {
        return null
    }

    const handleLanguageSelect = (
        event: React.MouseEvent<HTMLAnchorElement>,
        targetPrId: string,
        targetLanguage: string,
    ) => {
        event.preventDefault()

        setPressReleasePreferredLanguage(resolveLanguage(targetLanguage) as SupportedLanguage)
        navigate(`${getPressReleaseLink(companyId, targetPrId)}${location.search}`)
    }

    return (
        <List sx={{ margin: 0, padding: 0, textAlign: 'right', display: 'flex' }}>
            {translationOptions.map((translation) => (
                <Link
                    key={translation.prId}
                    to={getPressReleaseLink(companyId, translation.prId)}
                    onClick={(event) => handleLanguageSelect(event, translation.prId, translation.language)}
                >
                    <img
                        alt={translation.language}
                        title={translation.language}
                        src={flagPath(mapLanguageToCountry(translation.language))}
                        height={18}
                        style={{ marginLeft: 14 }}
                    />
                </Link>
            ))}
        </List>
    )
}
